module.exports = __webpack_public_path__ + "static/img/page_05.111bea93.png";